
import { Vue } from "vue-class-component";

export default class TrashConcentrated extends Vue {}
